// extracted by mini-css-extract-plugin
module.exports = {"Body":"SensorWarningModal_Body__23WG2","Warning":"SensorWarningModal_Warning__2SFNS","Text":"SensorWarningModal_Text__1u4z6"};